// extracted by mini-css-extract-plugin
module.exports = {"frame":"requestToHolder_frame__EmviN"};